// Ritorno al login quando la sessione non vale più (token revocato o scaduto, azienda
// archiviata): il server risponde 401 a ogni chiamata, ma le pagine chiamano $fetch ognuna
// per conto suo e nessuna gestiva quel 401. Il plugin `sessione-scaduta.client.js` usa
// questa regola su tutte le risposte.

// Query con cui il plugin apre il login: la pagina di login mostra il motivo dell'uscita.
export const QUERY_SESSIONE_SCADUTA = "scaduta";

const percorsoDi = (url) => {
  const testo = String(url ?? "");
  try {
    return new URL(testo, "http://x").pathname;
  } catch {
    return testo;
  }
};

/**
 * true se la risposta dice che la sessione non è più valida e l'utente va riportato al
 * login: un 401 di un'API, esclusi i percorsi di accesso (`/api/auth/*`), mentre l'utente
 * è nell'area riservata (`/admin/*`). Il login, il recupero password e il kiosk hanno le
 * loro regole e restano dove sono.
 */
export function deveTornareAlLogin({ status, url, percorsoPagina }) {
  if (Number(status) !== 401) return false;
  const api = percorsoDi(url);
  if (!api.startsWith("/api/") || api.startsWith("/api/auth/")) return false;
  return String(percorsoPagina ?? "").startsWith("/admin");
}
